import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  @ViewChild('staticTabs', { static: false }) private staticTabs: TabsetComponent;

  ngOnInit(): void {
    console.log(this.staticTabs);


  }

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
  }

  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) { }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
      Object.assign({}, { class: 'At-ModalCreatePost modal-dialog-centered' })
    );
  }

  isShare: boolean = false; // hidden by default
  isShowComment: boolean = false; // hidden by default
  isShowActivity: boolean = false; // hidden by default

  div1:boolean=true;
  div2:boolean=false;
  div3:boolean=false;


  toggleShare() {
    this.isShare = !this.isShare;
  }

  toggleCloseActivity(){
    this.isShare = !this.isShare;
  }

  toggleShowComment() {
    this.isShowComment = !this.isShowComment;
  }

  toggleShowActivity() {
    this.isShowActivity = !this.isShowActivity;
  }

  div1Function(){
    this.div2=true;
    this.div1=false;
    this.div3=false;
  }

  div2Function(){
      this.div3=true;
      this.div2=false;
      this.div1=false;
  }

  back1Function(){
    this.div1=true;
    this.div2=false;
    this.div3=false;
  }

  back2Function(){
    this.div2=true;
    this.div3=false;
    this.div1=false;
  }

  closeShare = () => this.isShare = false;
  closeComment = () => this.isShowComment = false;
  closeActivity = () => this.isShowActivity = false;

}
